export const initialState = {
    isFetching: false,
    updateBundles: false,
    isError: false,
    elements: {},
    collections: []
};

const getCollections = (state, data) => {
    const newCollections = {};

    if (Array.isArray(data) && data.length) {
        data.forEach(bundle => {
            if (bundle.items && bundle.type) {
                const items = bundle.items && bundle.items.map(element => element.id);
                const lowerType = bundle.type.toLowerCase();

                newCollections[lowerType] = bundle;
                newCollections[lowerType].items = items;
            }
        });
    }

    return {
        ...newCollections
    };
};

const getElements = (state, array) => {
    if (!Array.isArray(array) || array.length === 0) {
        return state.elements;
    }

    const newElements = {};

    array.forEach(bundle => {
        bundle.items.forEach(item => {
            newElements[item.id] = item;
        });
    });

    return {
        ...state.elements,
        ...newElements
    };
};

const bundles = (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_BUNDLES': {
            return {
                ...state,
                isFetching: true,
                updateBundles: false
            };
        }
        case 'RECEIVE_BUNDLES': {
            return {
                ...state,
                elements: getElements(state, action.data),
                collections: getCollections(state, action.data),
                lastCollectionUrl: action.url,
                isFetching: false,
                updateBundles: false
            };
        }
        case 'ERROR_BUNDLES': {
            return {
                isError: true,
                isFetching: false
            };
        }
        case 'UPDATE_BUNDLES': {
            return {
                ...state,
                updateBundles: action.value
            };
        }
        default:
            return state;
    }
};

export default bundles;
